const url = {
  baseUrl: 'https://webserver.technicise.eu',
}

export default url
